/* eslint-disable react/button-has-type */
import React from 'react';
import DashCardBg from '../../../../assets/images/image_dashcard_bg.svg';
import roundUp from '../../../../utils/roundUp';

type CardProps = {
  monthSummary: {
    month: string;
    sales: number;
    salesCount: number;
    cost: number;
    profit: number;
  };
  currencySymbol: string;
  onClick?: (value: any) => void;
  className?: string;
  tourGuide?: boolean;
  userRole?: string;
};

function MonthSummary({
  className,
  monthSummary,
  onClick,
  currencySymbol,
  tourGuide,
  userRole,
}: CardProps) {
  return (
    <div
      style={{ backgroundImage: `url(${DashCardBg})` }}
      className="min-h-[210px] border border-pos-dark-yellow rounded-md bg-cover 
      bg-no-repeat bg-bottom p-5"
    >
      <h2 className="font-semibold text-lg mb-4 text-center text-pos-dark-yellow">
        {monthSummary.month} Summary
      </h2>
      <div className="flex flex-col space-y-4">
        <div>
          <p className="text-pos-gray font-light text-xbase">
            Sale Transactions:
          </p>
          <h3 className="font-semibold text-2xl inline-flex items-center whitespace-pre">
            {monthSummary.salesCount}{' '}
            <span className="text-xbase">out of </span> 1000
          </h3>
        </div>

        <div className={`space-y-3 ${tourGuide ? 'opacity-30' : ''}`}>
          <div>
            <p className="text-pos-gray font-light text-sm">Sales:</p>
            <h3 className="font-semibold text-xl inline-flex items-center whitespace-pre">
              <span className="text-xs">{currencySymbol}</span>
              {roundUp(monthSummary.sales, 2).toFixed(2)}
            </h3>
          </div>
          <div>
            <p className="text-pos-gray font-light text-sm">Cost:</p>
            {userRole &&
            ['Admin', 'Webmaster', 'Manager'].includes(userRole) ? (
              <h3 className="font-semibold text-xl inline-flex items-center whitespace-pre">
                <span className="text-xs">{currencySymbol}</span>
                {roundUp(monthSummary.cost, 2).toFixed(2)}
              </h3>
            ) : (
              <h3 className="font-semibold text-xl inline-flex items-center whitespace-pre bg-black rounded-sm px-2">
                <span className="text-xs">{currencySymbol}</span>
                {roundUp(0, 2).toFixed(2)}
              </h3>
            )}
          </div>
          <div>
            <p className="text-pos-gray font-light text-sm">
              Net Sales (Profit):
            </p>
            {userRole &&
            ['Admin', 'Webmaster', 'Manager'].includes(userRole) ? (
              <h3 className="font-semibold text-xl inline-flex items-center whitespace-pre">
                <span className="text-xs">{currencySymbol}</span>
                {roundUp(monthSummary.profit, 2).toFixed(2)}
              </h3>
            ) : (
              <h3 className="font-semibold text-xl inline-flex items-center whitespace-pre bg-black rounded-sm px-2">
                <span className="text-xs">{currencySymbol}</span>
                {roundUp(0, 2).toFixed(2)}
              </h3>
            )}
          </div>
        </div>

        {tourGuide && (
          <p className="text-left text-pos-black text-base">
            Want to know your profit for this month?{' '}
            <button
              onClick={onClick}
              type="button"
              className="inline-block text-pos-hyperlink font-light hover:underline underline-offset-2"
            >
              Start your first sale!
            </button>
          </p>
        )}
      </div>
    </div>
  );
}

MonthSummary.defaultProps = {
  className: '',
  onClick: undefined,
  tourGuide: undefined,
  userRole: undefined,
};

export default MonthSummary;
